import { render, staticRenderFns } from "./DFGuideText2.vue?vue&type=template&id=03e305ca&"
import script from "./DFGuideText2.vue?vue&type=script&lang=js&"
export * from "./DFGuideText2.vue?vue&type=script&lang=js&"
import style0 from "./DFGuideText2.vue?vue&type=style&index=0&id=03e305ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports